import { JobseekerAttachmentTypes } from 'constants/enums';

export const cvFileTypes = '.pdf,.doc,.docx';
export const offerLetterFileTypes = '.pdf,.doc,.docx';
export const commonFileTypes = '.pdf,.doc,.docx,.jpeg,.jpg,.png';

export const JOBSEEKER_ATTACHMENTS_FILE_TYPES = {
  [JobseekerAttachmentTypes.CV]: cvFileTypes,
  [JobseekerAttachmentTypes.IdCard]: commonFileTypes,
  [JobseekerAttachmentTypes.OfferLetter]: commonFileTypes,
  [JobseekerAttachmentTypes.Passport]: commonFileTypes,
  [JobseekerAttachmentTypes.UserPrivateDocument]: commonFileTypes,
  [JobseekerAttachmentTypes.Visa]: commonFileTypes,
  [JobseekerAttachmentTypes.WorkPermit]: commonFileTypes,
  [JobseekerAttachmentTypes.DriverLicense]: commonFileTypes,
  [JobseekerAttachmentTypes.OtherJobseekerDocuments]: commonFileTypes
};
